export const chartColors = [
    '#4caf50',
    '#2196f3',
    '#ff9800',
    '#9c27b0',
    '#f44336',
    '#00bcd4',
    '#e91e63',
    '#ffc107',
    '#3f51b5',
    '#8bc34a',
    '#ff5722',
    '#673ab7',
    '#cddc39',
    '#009688',
    '#795548',
    '#607d8b',
    '#ffeb3b',
    '#f06292',
    '#4db6ac',
    '#9575cd',
    '#ba68c8',
    '#81d4fa',
    '#aed581',
];
